<template>

  <div class="input-container">
  	<textarea ref="input-textarea" :disabled="disabled" v-model="value" @keyup="$bus.emit('app:keyup', $event)" @keydown="$bus.emit('app:keydown', $event)" @input="handleInput"></textarea>
  </div>

</template>

<script>
import { nextTick } from 'vue'
export default {

  name: 'Input',

  data() {

    return {
    	value: '',
    	hasStarted: false,
    	disabled: false,
    }
  },

  methods: {
  	handleInput(e) {
  		if (!this.hasStarted) {
  			this.$bus.emit('app:started')
  			this.hasStarted = true
  		}
			this.$bus.emit('app:increment', e.target.value.slice(-1))
  	},
  	handleFinished() {
  		this.disabled = true
  	},
  	handleReset() {
  		this.hasStarted = false
  		this.disabled = false
  		this.value = ''
      nextTick().then( () => {
        this.$refs['input-textarea'].focus()
      })
  	}
  },

  mounted() {
  	this.$bus.on('app:finished', this.handleFinished)
  	this.$bus.on('app:reset', this.handleReset)
  },
}
</script>

<style lang="css" scoped>
 .input-container {
   width: 80vw;
   margin: auto;
   height: 100px;
 }
 .input-container textarea {
  width: 100%;
  height: 100%;
  font-size: 27px;
}
</style>